import { Component } from '@angular/core';
import { COMPANY_PHONE_NUMBER } from 'src/app/constants/app.constants';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {

  public COMPANY_PHONE_NUMBER = COMPANY_PHONE_NUMBER;

  constructor(
    public userService: UserService
  ) {}

  links: { name: string; route: string }[] = [
    {
      name: 'Privacy policy',
      route: 'privacy'
    },
    {
      name: 'Cookie policy',
      route: 'cookies'
    },
    {
      name: 'Terms of Website Use',
      route: 'website-use'
    },
    {
      name: 'Terms and Conditions',
      route: 'terms-and-conditions'
    },
    {
      name: 'Acceptable Use',
      route: 'acceptable-use'
    },
  ];
  year: number = new Date().getFullYear();

}
